import { render } from "./OrderItemList.vue?vue&type=template&id=1e898f40&scoped=true&ts=true"
import script from "./OrderItemList.vue?vue&type=script&lang=ts"
export * from "./OrderItemList.vue?vue&type=script&lang=ts"

import "./OrderItemList.vue?vue&type=style&index=0&id=1e898f40&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.25_vue@3.5.25_typescript@5.9.3__webpack@5.103.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1e898f40"]])

export default __exports__